module.exports = __webpack_public_path__ + "img/Gmaths.vn.6b2a7842.png";